import { IMemberInteriorSettings } from "../../interfaces/memberInteriorSettings/iMemberInteriorSettings";
import { IAccountIntegration } from "../../interfaces/memberInteriorSettings/iAccountIntegration";
import { IEmailNotificationsSetting } from "../../interfaces/memberInteriorSettings/iEmailNotificationsSetting";
import { EmailNotificationsSetting } from "./emailNotificationsSetting";
import { AccountIntegration } from "./accountIntegration";

export class MemberInteriorSettings implements IMemberInteriorSettings {
	lastName: string;
	firstName: string;
	workEmail: string;
	workPhone: string;
	personalEmail: string;
	personalPhone: string;
	preferredName: string;
	accountIntegrations: IAccountIntegration[];
	emailNotificationsSettings: IEmailNotificationsSetting[];

	constructor(memberInteriorSettings: IMemberInteriorSettings = {} as IMemberInteriorSettings) {
		this.emailNotificationsSettings = !!memberInteriorSettings.emailNotificationsSettings ?
			memberInteriorSettings.emailNotificationsSettings.map((element: IEmailNotificationsSetting) => {
				return new EmailNotificationsSetting(element);
			}) : [];

		this.accountIntegrations = !!memberInteriorSettings.accountIntegrations ?
			memberInteriorSettings.accountIntegrations.map((element: IAccountIntegration) => {
				return new AccountIntegration(element);
			}) : [];

		this.lastName = memberInteriorSettings.lastName || '';
		this.firstName = memberInteriorSettings.firstName || '';
		this.workEmail = memberInteriorSettings.workEmail || '';
		this.workPhone = memberInteriorSettings.workPhone || '';
		this.personalEmail = memberInteriorSettings.personalEmail || '';
		this.personalPhone = memberInteriorSettings.personalPhone || '';
		this.preferredName = memberInteriorSettings.preferredName || '';
	}
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/memberInteriorSettings/memberInteriorSettings.ts